import type {
  GetLifecycleRolesQuery,
  GetRolePermissionMatrixQuery,
  GetRolePermissionMatrixQueryVariables,
  CreateLifecycleRoleMutation,
  CreateLifecycleRoleMutationVariables,
  DuplicateLifecycleRoleMutation,
  DuplicateLifecycleRoleMutationVariables,
  UpdateLifecycleRoleMutation,
  UpdateLifecycleRoleMutationVariables,
  DeleteLifecycleRoleMutation,
  DeleteLifecycleRoleMutationVariables,
  SaveRolePermissionMatrixMutation,
  SaveRolePermissionMatrixMutationVariables,
} from "../../remote/gql/graphql";
import type { ClientReturnType } from "../types";

import {
  getLifecycleRolesDoc,
  getRolePermissionMatrixDoc,
  createLifecycleRoleDoc,
  duplicateLifecycleRoleDoc,
  updateLifecycleRoleDoc,
  deleteLifecycleRoleDoc,
  saveRolePermissionMatrixDoc,
} from "../../remote/queries/lifecycleRoles.gql";
import { AlaffiaClientModule } from "./modules";
export class LifecycleRolesModule extends AlaffiaClientModule {
  private insurerContext = (insurerId?: string) =>
    insurerId
      ? { fetchOptions: { headers: { "X-Insurer-Id": insurerId } } }
      : undefined;
  getLifecycleRoles = async (input: {
    insurerId?: string;
  }): ClientReturnType<GetLifecycleRolesQuery["lifecycleRoles"]> => {
    const result = await this.runGqlQuery(
      getLifecycleRolesDoc,
      input,
      "getLifecycleRoles",
      this.insurerContext(input.insurerId),
    );
    return {
      data: result.data?.lifecycleRoles ?? null,
      error: result.error ?? null,
    };
  };
  getRolePermissionMatrix = async (
    input: GetRolePermissionMatrixQueryVariables & { insurerId?: string },
  ): ClientReturnType<GetRolePermissionMatrixQuery["rolePermissionMatrix"]> => {
    const result = await this.runGqlQuery(
      getRolePermissionMatrixDoc,
      input,
      "getRolePermissionMatrix",
      this.insurerContext(input.insurerId),
    );
    return {
      data: result.data?.rolePermissionMatrix ?? null,
      error: result.error ?? null,
    };
  };
  createLifecycleRole = async (
    input: CreateLifecycleRoleMutationVariables & { insurerId?: string },
  ): ClientReturnType<CreateLifecycleRoleMutation["createLifecycleRole"]> => {
    const result = await this.runGqlMutation(
      createLifecycleRoleDoc,
      input,
      "createLifecycleRole",
      this.insurerContext(input.insurerId),
    );
    return {
      data: result.data?.createLifecycleRole ?? null,
      error: result.error ?? null,
    };
  };
  duplicateLifecycleRole = async (
    input: DuplicateLifecycleRoleMutationVariables & { insurerId?: string },
  ): ClientReturnType<
    DuplicateLifecycleRoleMutation["duplicateLifecycleRole"]
  > => {
    const result = await this.runGqlMutation(
      duplicateLifecycleRoleDoc,
      input,
      "duplicateLifecycleRole",
      this.insurerContext(input.insurerId),
    );
    return {
      data: result.data?.duplicateLifecycleRole ?? null,
      error: result.error ?? null,
    };
  };
  updateLifecycleRole = async (
    input: UpdateLifecycleRoleMutationVariables & { insurerId?: string },
  ): ClientReturnType<UpdateLifecycleRoleMutation["updateLifecycleRole"]> => {
    const result = await this.runGqlMutation(
      updateLifecycleRoleDoc,
      input,
      "updateLifecycleRole",
      this.insurerContext(input.insurerId),
    );
    return {
      data: result.data?.updateLifecycleRole ?? null,
      error: result.error ?? null,
    };
  };
  deleteLifecycleRole = async (
    input: DeleteLifecycleRoleMutationVariables & { insurerId?: string },
  ): ClientReturnType<DeleteLifecycleRoleMutation["deleteLifecycleRole"]> => {
    const result = await this.runGqlMutation(
      deleteLifecycleRoleDoc,
      input,
      "deleteLifecycleRole",
      this.insurerContext(input.insurerId),
    );
    return {
      data: result.data?.deleteLifecycleRole ?? null,
      error: result.error ?? null,
    };
  };
  saveRolePermissionMatrix = async (
    input: SaveRolePermissionMatrixMutationVariables & { insurerId?: string },
  ): ClientReturnType<
    SaveRolePermissionMatrixMutation["saveRolePermissionMatrix"]
  > => {
    const result = await this.runGqlMutation(
      saveRolePermissionMatrixDoc,
      input,
      "saveRolePermissionMatrix",
      this.insurerContext(input.insurerId),
    );
    return {
      data: result.data?.saveRolePermissionMatrix ?? null,
      error: result.error ?? null,
    };
  };
}
